<script>
  import { MetaTags } from 'svelte-meta-tags';

  import {cmToFeetAndInches} from './utils/numConvert.ts';
  import {fracToString} from './utils/toString.ts';
  import Links from "./Links.svelte";
  import MeterForm from "./MeterForm.svelte";
  import { _ } from 'svelte-i18n';

  export let meter;

  export const {inches, feet, nextInch} = cmToFeetAndInches(parseFloat(meter) * 100)
</script>

<MetaTags title={$_('meters.howManyInches', {notation: 'scientific', values: {meter}})} description={$_('meters.convertMeters')} />

<div class="results">
  <h1>{$_('meters.howManyInches', {notation: 'scientific', values: {meter}})}</h1>

  <p>{$_('meters.meters', {notation: 'scientific', values: {meter}})}<strong>{$_('meters.feet', {values: {feet}})} {@html $_('meters.inches', {values: {nextInch, inches: fracToString(inches)}})}</strong></p>
</div>

<MeterForm meters={meter} />

<Links title="More meters to inches conversions" bind:base={meter} />